<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-09-16 09:03:53
 * @LastEditTime: 2023-05-05 14:27:12
 * @LastEditors: mdb
-->
<template>
  <a-form ref="formRef" :model="dataForm" autocomplete="off" scrollToFirstError>
    <dc-layout-card :title="props.title" :span="6">
      <dc-form-item :label="t('marketing.活动名称')" name="activityName" :rules="formRules.input">
        <CosInput
          v-model:value="dataForm.activityName"
          :maxlength="100"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :label="t('marketing.来源渠道')" name="channelId" :rules="formRules.select">
        <ParamCodeCascader
          v-model:value="dataForm.channelId"
          :options="paramCodeData[props.paramCode]"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :label="t('marketing.活动负责人')" name="follower" :rules="formRules.select">
        <UserSelect
          v-model:value="dataForm.follower"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item :label="t('marketing.活动时间')" name="startTime" :rules="formRules.select">
        <CosRangePicker
          v-model:startTime="dataForm.startTime"
          v-model:endTime="dataForm.endTime"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item :label="t('marketing.选择模板')" name="activityTemplateId" :rules="formRules.select">
        <CosSelect
          v-model:value="dataForm.activityTemplateId"
          :fieldNames="{ label: 'name', value: 'id' }"
          :options="templateEnum"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
          @popupScroll="popupScroll"
          allowClear
        />
      </dc-form-item>
      <dc-form-item :label="t('marketing.活动地点')" name="eventAddress" :rules="formRules.input">
        <CosInput
          v-model:value="dataForm.eventAddress"
          :maxlength="256"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <a-col :span="6" v-if="props.type !== 'view'">
        <div class="flex cos-both-form-item">
          <a-form-item
            style="width: 70%"
            :label="t('marketing.活动预算')"
            name="eventBudge"
            :rules="[{ required: true, message: t('common.pleaseInput') }]"
          >
            <CosInputNumber
              v-model:value="dataForm.eventBudge"
              :maxlength="15"
              :min="0"
              :controls="false"
              :view="props.type === 'view'"
              cosType="money"
              :formatter="(inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item
            label="annualSalesUnit"
            style="width: 30%"
            name="eventBudgeCurrency"
            class="hide-label"
            :rules="[{ required: true, message: t('common.pleaseSelect') }]"
          >
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="dataForm.eventBudgeCurrency"
              :view="props.type === 'view'"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item
        v-else
        :label="t('marketing.活动预算')"
        name="eventBudgeCurrency"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <ParamCodesSelect
          :cosBeforeDes="dataForm.eventBudge?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="dataForm.eventBudgeCurrency"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item v-if="props.type === 'view'" :label="t('follow.createByName')" name="createBy">
        <UserSelect v-model:value="dataForm.createBy" view />
      </dc-form-item>
      <dc-form-item v-if="props.type === 'view'" :label="t('business.wwys5u')" name="createTime">
        <CosInput v-model:value="dataForm.createTime" view />
      </dc-form-item>
      <dc-form-item v-if="props.type === 'view'" :label="t('custom.申请单号')" name="oaApplyNo">
        <CosInput v-model:value="dataForm.oaApplyNo" view />
      </dc-form-item>
      <dc-form-item v-if="props.type === 'view'" name="enableFlag" :label="t('operate.lbczwf')">
        <CosSelect :fieldNames="{ label: 'name' }" v-model:value="dataForm.enableFlag" view :options="statusEnum" />
      </dc-form-item>
      <dc-form-item v-if="props.type === 'view'" :label="t('clue.审核状态')">
        <CosSelect v-model:value="dataForm.oaAuditStatus" :options="oaReviewStatus" view />
      </dc-form-item>
      <dc-form-item :label="t('common.remark')" name="remark" :span="12">
        <CosTextarea
          v-model:value="dataForm.remark"
          :maxlength="2000"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item :label="t('follow.UploadAttachments')" name="otherFile" :span="24">
        <UploadFile
          v-model:value="dataForm.otherFile"
          valueType="array"
          :disabled="props.type === 'view'"
          :view="props.type === 'view'"
        />
        <div v-if="props.type !== 'view'" class="tips">
          <p>
            {{ t('tips.templeDown') }} :
            <!-- <a
            href="/Example of Global Expo Budget Plan.xlsx"
            target="_blank"
            >Example of Global Expo Budget Plan.xlsx</a
          > -->
            <a-button style="padding: 0" type="link" primary @click="exportTemple">
              Example of Global Expo Budget Plan.xlsx
            </a-button>
          </p>
        </div>
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card v-if="props.type === 'view'" :title="t('marketing.审核记录')" :span="6">
      <cos-table
        :columns="reviewHistoryColumns"
        style="padding: 0 6px 6px 6px"
        :needPage="false"
        :data-source="reviewHistory"
        serial
        rowKey="nodeId"
        tableId="marketingActivityCodeReviewHistory"
        :dynamicColumnSetting="false"
      >
      </cos-table>
    </dc-layout-card>
    <!-- <dc-layout-card title="销售名片" :span="24" v-if="props.type === 'view'">
      <a-col>
        <cos-table
          :columns="columns"
          :dataSource="dataForm.businessCardVoList"
          :tableId="props.subdomain === 'fbu' ? 'DcCosFbuActivityCodeViewCardList' : 'DcCosLbuActivityCodeViewCardList'"
          :needPage="false"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'action'">
              <MoreButton>
                <a-button type="link" @click="showModal('zh-CN', record)">中文二维码</a-button>
                <a-button type="link" @click="showModal('en-US', record)">英文二维码</a-button>
              </MoreButton>
            </template>
          </template>
        </cos-table>
      </a-col>

      <a-modal v-model:visible="visible" :title="qrCodeTitle" @ok="handleOk">
        <template #footer>
          <a-button key="submit" type="primary" @click="handleCopy">复制链接</a-button>
          <a-button key="submit" type="primary" @click="handleOk">下载二维码</a-button>
        </template>
        <vue-qr
          :margin="0"
          :size="400"
          :text="qrCodeUrl"
          :logoSrc="qrCodeLogoEnum[props.subdomain]"
          :logoScale="0.25"
          :logoMargin="6"
          :correctLevel="0"
          ref="qrCodeRef"
        />
      </a-modal>
    </dc-layout-card> -->
  </a-form>

  <cos-footer-button
    v-model:value="dataForm"
    :formRef="formRef"
    :resetValue="initForm"
    :loading="loading"
    :disabled="props.type === 'view'"
    :permissionPage="permissionPage"
    :editUrl="`/${props.subdomain}/activityCode/edit?id=${queryId}`"
    hideOk
  >
  <a-button type="primary" @click="onSubmit(true)" v-if="props.type !== 'view' && !skipReview && !isSubmit">{{
      t('btn.saveOaDraft')
    }}</a-button>
    <a-button type="primary" v-if="props.type !== 'view'" @click="onSubmit()">{{ t('btn.save&Submit') }}</a-button>
  </cos-footer-button>
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, computed, onBeforeMount, watchEffect, unref } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { goBack } from '@/hooks/cosRouter'
import { message } from '@dc-platform/dc-components'
import { selectForNumberValidate } from '@/utils/validate'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { listByParamCodes } from '@/api/common'
import { oaReviewStatus } from '@/views/overseasSales/commonEnum/dataConfig'
import {
  activityCreateAndSubmit,
  activityOAUpdate,
  activityDetail,
  templateList,
  activitySaveDraft
} from '@/api/marketing/marketingManage'
import { paramCodesDataFilter, downloadFileByBase64 } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { ParamCodeItem } from '@/typings/common'
import UploadFile from '@/components/UploadFile'
import { useI18n } from 'vue-i18n'
import CosTable from '@/components/CosTable/src/cosTable.vue'
import { newClientEvaluationReviewHistory } from '@/api/overseasSales/newClientEvaluation'
const { t } = useI18n()

const statusEnum = computed(() => [
  { name: t('marketing.可用'), value: true, color: '#3FAC46' },
  { name: t('marketing.不可用'), value: false, color: '#DF443B' }
])
const props = defineProps<{
  type: 'add' | 'edit' | 'view'
  subdomain: 'fbu' | 'lbu' | 'ofbu'
  title: string
  paramCode: string
}>()
watchEffect(() => {
  if (props.type === 'view' && props.subdomain == null) {
    console.error('当详情页时, props subdomain 必传')
  }
})

const exportTemple = () => {
  const eleLink = document.createElement('a')
  eleLink.download = window.API_URL + '/zbu/api/activity/qrcode/template/download'
  eleLink.style.display = 'none'
  eleLink.href = window.API_URL + '/zbu/api/activity/qrcode/template/download'
  document.body.appendChild(eleLink)
  eleLink.click()
  document.body.removeChild(eleLink)
}

const permissionPage = computed(() => {
  const addPermissions = {
    fbu: { save: 'fbu_activity_add_btn' },
    lbu: { save: 'lbu_activity_add_btn' },
    ofbu: { save: 'ofbu_activity_add_btn' }
  }
  const otherPermissions = {
    fbu: { edit: 'fbu_activity_edit_btn', save: 'fbu_activity_edit_btn' },
    lbu: { edit: 'lbu_activity_edit_btn', save: 'lbu_activity_edit_btn' },
    ofbu: { edit: 'ofbu_activity_edit_btn', save: 'ofbu_activity_edit_btn' }
  }
  return props.type === 'add' ? addPermissions[props.subdomain] : otherPermissions[props.subdomain]
})
const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  [props.paramCode]: [] // 来源渠道
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [props.paramCode, 'ofbu_currency']
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    paramCodeData.value = res.data
  })
}
// const partnerEnum = ref()
// const getPartner = () => {
//   partnerDropList().then((res) => {
//     partnerEnum.value = res.data
//   })
// }
const templateEnum = ref<any[]>([])
const pageUtils = reactive({ pageNumber: 1, pageSize: 100 })
const getTemplate = () => {
  templateList(pageUtils).then((res) => {
    templateEnum.value = [...templateEnum.value, ...res.data.items]
  })
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageUtils.pageNumber = pageUtils.pageNumber + 1
    getTemplate()
  }
}
onBeforeMount(() => {
  getByParamCodes()
  // getPartner()
  getTemplate()
})

const loading = ref(false)
const formRef = ref<FormInstance>()
const queryId = computed(() => route.query.id as string)
const initForm = ref<any>({
  activityName: undefined,
  channelId: undefined,
  follower: undefined,
  startTime: undefined,
  endTime: undefined,
  partnerId: undefined,
  activityTemplateId: undefined,
  remark: undefined
})
const dataForm = ref({})
const formRules = reactive({
  input: [{ required: true, message: t('common.pleaseInput') }],
  select: [{ required: true, message: t('common.pleaseSelect') }],
  selectNumber: [{ required: true, validator: selectForNumberValidate }]
})
const reviewHistoryColumns = computed(() => [
  {
    title: t('common.operator'),
    dataIndex: 'operatorName'
  },
  {
    title: t('common.operatorDate'),
    dataIndex: 'createTime',
    type: 'time'
  },
  {
    title: t('marketing.审核意见'),
    dataIndex: 'processSuggject',
    ellipsis: false
  }
])
const reviewHistory = ref<any[]>([])
const fetchReviewHistory = async (oaId: number) => {
  const res = await newClientEvaluationReviewHistory({ id: oaId })
  reviewHistory.value = res.data
}
const route = useRoute()
const getDetails = () => {
  loading.value = true
  activityDetail({ activityQrcodeId: route.query.id as string })
    .then((res) => {
      if (props.type === 'edit') {
        res.data.activityQrcodeId = res.data.id
      } else if (props.type === 'view') {
        fetchReviewHistory(res.data.oaId)
      }
      // Object.assign(initForm, res.data)
      // Object.assign(dataForm, res.data)
      // console.log('dataForm:', dataForm.value)
      dataForm.value = res.data
    })
    .finally(() => {
      loading.value = false
    })
}
onBeforeMount(() => {
  if (props.type !== 'add') {
    getDetails()
  }
})

const skipReview = computed(() => route.query.skipReview === '1')
const isSubmit = computed(() => route.query.isSubmit === '1')

const handleSubmitAdd = async () => {
  const v = await formRef.value?.validate()
  if (!v) return
  loading.value = true
  const p = dataForm.value
  p.skipReview = skipReview
  activityCreateAndSubmit(p)
    .then(() => {
      message.success(route.query.isSubmit === '1' ? t('marketing.提交市场活动成功') : t('marketing.新增市场活动成功'))
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}
const handleSubmitEdit = () => {
  loading.value = true
  const p = dataForm.value
  p.skipReview = skipReview
  activityOAUpdate(p)
    .then(() => {
      message.success(t('marketing.修改市场活动成功'))
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}

const handleSaveDraft = () => {
  loading.value = true
  const p = dataForm.value
  p.skipReview = skipReview
  activitySaveDraft(p)
    .then(() => {
      message.success(t('marketing.保存市场活动成功'))
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}

const onSubmit = (isEdit = false) => {
  if (isEdit) {
    handleSaveDraft()
  // } else if (props.type === 'edit') {
  //   handleSubmitEdit()
  // } else if (props.type === 'add' || route.query.isSubmit === '1') {
  } else {
    handleSubmitAdd()
  }
}

// const qrCodeRef = ref()
// const qrCodeTitle = ref('')
// const visible = ref<boolean>(false)
// const currentRow = ref()
// const qrCodeType = ref<'zh-CN' | 'en-US'>()
// const qrCodeUrl = ref('')
// const qrCodeLogoEnum = {
//   fbu: require('@/assets/logo_gucang.png'),
//   lbu: require('@/assets/logo_yuntu.png')
// }
// const handleCopy = () => {
//   clipboardRef.value = qrCodeUrl.value
//   if (unref(copiedRef)) {
//     message.success('复制成功')
//   } else {
//     message.error('该浏览器不支持自动复制!')
//   }
// }
// const showModal = (lang: 'zh-CN' | 'en-US', row: any) => {
//   const langEnum = { 'zh-CN': '中文二维码', 'en-US': '英文二维码' }
//   qrCodeType.value = lang
//   qrCodeTitle.value = langEnum[lang]
//   currentRow.value = row
//   qrCodeUrl.value = `${window.WEB_URL}/mobile.html#/businessCard?cardId=${row.id}&follower=${row.follower}&subdomain=${props.subdomain}&lang=${qrCodeType.value}`
//   visible.value = true
// }
// const handleOk = () => {
//   downloadFileByBase64(qrCodeRef.value.imgUrl, `${currentRow.value?.followerName}-${qrCodeType.value}`)
//   visible.value = false
// }
</script>
<script lang="ts">
export default { name: 'DetailForm' }
</script>

<style scoped></style>
